import {
  GET_REGISTRATION,
  GET_REGISTRATION_SUCCESS,
  GET_REGISTRATION_FAILED,
} from "./actionsTypes";

const initialState = {
  registration: null,
  loadingSettings: false,
  error: {
    message: "",
  },
};

const RegistrationReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_REGISTRATION:
      state = { ...state, loadingSettings: true };
      break;
    case GET_REGISTRATION_SUCCESS:
      state = { ...state, registration: action.payload, loadingSettings: false };
      break;
    case GET_REGISTRATION_FAILED:
      state = {
        ...state,
        error: {
          message: "Error",
        },
        loadingSettings: false,
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default RegistrationReducer;
